import script from "./app-system-weather.vue?vue&type=script&setup=true&lang=ts"
export * from "./app-system-weather.vue?vue&type=script&setup=true&lang=ts"

import "./app-system-weather.vue?vue&type=style&index=0&id=9f3613e0&lang=scss"

const __exports__ = script;

export default __exports__